export const FETCHED_SECTION_SETTINGS = 'FETCHED_SECTION_SETTINGS';
export const FETCHED_IMAGE_SETTINGS = 'FETCHED_IMAGE_SETTINGS';
export const FETCHED_SECTIONS_VIDEO_SETTINGS = 'FETCHED_SECTIONS_VIDEO_SETTINGS';


// WEBPACK FOOTER //
// ./src/containers/pages/settings/types.js